import { useEffect } from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

import RHFTextField from '../../../components/hook-form/RHFTextField';
import FormProvider from '../../../components/hook-form/FormProvider';

import validation from './validation';
// import RHFSelectStatic from '../../../components/hook-form/RHFSelectStatic';
import RHFSelector from '../../../components/hook-form/RHFSelector';
import RHFDatePicker from '../../../components/hook-form/RHFDatePicker';
import Enum from '../enum';
import { useMutationCustom, useQueryCustom } from '../../../utils/reactQueryHooks';
import axiosInstance from '../../../utils/axios';
import { fDateApi } from '../../../utils/formatTime';
import api from '../../../services/api';

const AddForm = ({ onClose, data }) => {
  const { travel } = useParams();
  const { t } = useTranslation();
  const paramId = data?.id;

  const methods = useForm({
    resolver: yupResolver(validation.schema()),
  });

  const {
    reset,
    watch,
    control,
    setValue,
    setError,
    handleSubmit,
    getValues,
    formState: { errors, isSubmitting },
  } = methods;

  // ----------------------------------------------------------------------------- SERVICE
  const creating = (params) => axiosInstance.post(Enum?.api?.base, params);
  const updating = (params) => axiosInstance.put(`${Enum?.api?.base}/${paramId}`, params);
  const getById = () => axiosInstance.get(`${Enum?.api?.base}/${paramId}`);
  // ------------------------------------------------------------------------------ Mutation
  const onSuccessMutating = () => {
    toast.success(t('successfully'));
    reset({
      [validation.fieldNames.order]: null,
      [validation.fieldNames.name]: '',
    });
    onClose();
  };
  // const onErrorMutating = (error) => {
  //   console.log({ error });
  //   const errorTitle = error?.response?.data?.message;
  //   const errors = Object.values(error?.response?.data?.errors || {});
  //   if (errors?.length) {
  //     errors?.map((x) => {
  //       return toast.error(x?.[0]);
  //     });
  //   } else toast.error(errorTitle);
  // };
  const { isLoading, mutate } = useMutationCustom({
    url: paramId ? updating : creating,
    name: `${Enum?.api?.base}_update`,
    invalidQuery: `${api.travel.base}_get_${travel}`,
    onSuccess: onSuccessMutating,
    // onError: onErrorMutating,
  });
  // ---------------------------------------
  const onSuccessDataById = (resData) => {
    console.log({ resData });
    // reset(resetParam);
  };
  const dataById = useQueryCustom({
    name: `getById_${Enum?.api?.base}_${paramId}`,
    url: getById,
    onSuccess: onSuccessDataById,
    enabled: !!paramId,
  });

  const watchStartDate = watch(validation.fieldNames.startDate);
  console.log({ watchStartDate });
  const onSubmit = async () => {
    const values = getValues();

    const reqData = {
      travel_id: travel,
      [validation.fieldNames.order]: values[validation.fieldNames.order]?.value,
      [validation.fieldNames.name]: values[validation.fieldNames.name],
    };

    console.log({ reqData });
    mutate(reqData);
  };

  useEffect(() => {
    if (data)
      reset({
        [validation.fieldNames.order]: Enum.enum.object[data.order],
        [validation.fieldNames.name]: data?.name,
      });
  }, [data]);

  console.log('* * * AddForm : ', { data });

  return (
    <Box
      sx={{
        // width: '100%',
        minWidth: { md: '550px' },
        // display: { xs: 'block', md: 'flex' },
        gap: 2,
        bgcolor: 'background.paper',
        borderRadius: 1,
        p: 4,
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          mb: '30px',
        }}
      >
        <Typography variant="h5">
          {data ? `شما در حال ویرایش  فرم ${data?.name} هستید!` : `شما در حال ایجاد یک فرم جدید هستید!`}
        </Typography>
      </Box>

      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          <RHFSelector options={Enum.enum.array} name={validation.fieldNames.order} label={'نوع فرم را انتخاب کنید.'} />
          <RHFTextField name={validation.fieldNames.name} label={'نام فرم'} />
        </Box>

        <Box
          sx={{
            display: 'flex',
            mt: 3,
            gap: 3,
          }}
        >
          <LoadingButton
            fullWidth
            // type="click"
            variant="outlined"
            color="success"
            loading={isLoading}
            onClick={onClose}
          >
            {'لغو'}
          </LoadingButton>

          <LoadingButton fullWidth type="submit" variant="contained" color={'success'} loading={isLoading}>
            {'تایید'}
          </LoadingButton>
        </Box>
      </FormProvider>
    </Box>
  );
};

export default AddForm;
